import { gql, useMutation } from "@apollo/client";

const TRACK_ATTRIBUTION_EVENT_MUTATION = gql`
  mutation TrackAttributionEvent($input: TrackAttributionEventInput!) {
    trackAttributionEvent(input: $input) {
      accepted
      duplicate
      error
      event {
        eventId
        idempotencyKey
        userId
        anonymousId
        eventType
        accountType
        membershipType
        variant
        sourceLandingPage
        referrerUrl
        occurredAt
        createdAt
      }
    }
  }
`;

export const useTrackAttributionEventMutation = () => {
  const [trackAttributionEvent, { loading, error, data }] = useMutation(
    TRACK_ATTRIBUTION_EVENT_MUTATION
  );

  return { trackAttributionEvent, loading, error, data };
};
